import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { isValid, parseISO } from 'date-fns';

function parseDate(object: unknown): Date | null {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?$/;
  if (typeof object === 'string' && isoDateRegex.test(object)) {
    const date = parseISO(object);
    if (isValid(date)) {
      return date;
    }
  }
  return null;
}

function parseDates(obj: unknown): unknown {
  if (obj instanceof Date) {
    return obj;
  }
  const date = parseDate(obj);
  if (date != null) {
    return date;
  }
  if (Array.isArray(obj)) {
    return obj.map(parseDates);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, parseDates(v)]));
  }
  return obj;
}

function convertDates(obj: unknown): unknown {
  if (obj instanceof Date) {
    return obj.toISOString();
  }
  if (Array.isArray(obj)) {
    return obj.map(convertDates);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, convertDates(v)]));
  }
  return obj;
}

export const dateInterceptor: HttpInterceptorFn = (req, next) => {
  let request = req;
  if (req.body && req.responseType === 'json') {
    request = req.clone({ body: convertDates(req.body) });
  }
  return next(request).pipe(
    map((event) => {
      if (event.type === HttpEventType.Response && event.body && req.responseType === 'json') {
        return event.clone({ body: parseDates(event.body) });
      }
      return event;
    }),
  );
};
